<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { MenuUnfoldOutlined } from '@ant-design/icons-vue';
import SideMenu from '@/components/navigation/SideMenu.vue';

const props = defineProps({
    collapsed: {
        type: Boolean,
        required: true
    },
    isMobile: {
        type: Boolean,
        required: true
    }
});

const emit = defineEmits(['update:collapsed']);

const router = useRouter();

const goToWelcome = () => {
    router.push('/welcome');
};

const toggleCollapsed = () => {
    emit('update:collapsed', !props.collapsed);
};

// 建立計算屬性來處理雙向綁定
const collapsedModel = computed({
    get: () => props.collapsed,
    set: (value) => emit('update:collapsed', value)
});
</script>

<template>
    <!-- 手機版遮罩 -->
    <div
        v-if="isMobile && !collapsed"
        class="fixed inset-0 bg-black bg-opacity-50 z-40"
        @click="$emit('update:collapsed', true)"
    ></div>

    <!-- 側選單 -->
    <a-layout-sider
        v-model:collapsed="collapsedModel"
        collapsible
        :trigger="null"
        theme="light"
        class="no-print flex flex-col shadow-lg border-r border-gray-200 transition-transform duration-300"
        :class="{
            'fixed left-0 top-0 h-screen z-[100]': isMobile,
            'fixed left-0 top-0 h-screen z-30': !isMobile,
            'translate-x-[-100%]': isMobile && collapsed,
            'translate-x-0': isMobile && !collapsed
        }"
        :style="{ position: 'fixed' }"
    >
        <!-- 管理員後台的標題 /Crown Icon -->
        <div
            class="fixed z-10 flex h-16 min-h-16 w-full items-center justify-between border-b border-slate-200/90 bg-white/95 shadow-sm backdrop-blur-md [box-shadow:inset_0_-2px_0_0_rgba(102,209,171,0.28)]"
        >
            <div
                class="mx-3 flex h-8 items-center justify-center transition-all duration-300"
                :style="{ width: collapsed ? '40px' : 'auto', minWidth: collapsed ? '40px' : '140px' }"
            >
                <div class="overflow-hidden whitespace-nowrap">
                    <div
                        v-if="!collapsed && !(isMobile && !collapsed)"
                        class="flex cursor-pointer items-center gap-2"
                        @click="goToWelcome"
                    >
                        <img
                            src="@/assets/logo.png"
                            alt="Logo"
                            class="h-7 w-6 object-contain"
                            :class="isMobile ? 'w-12' : ''"
                        />
                        <span
                            class="text-lg font-semibold tracking-tight text-[#272b36]"
                        >
                            資產負債管理
                        </span>
                    </div>
                    <img
                        v-if="collapsed && !isMobile"
                        src="@/assets/logo.png"
                        alt="Logo"
                        class="w-6 h-7 ml-2"
                    />
                </div>
            </div>

            <!-- 手機版選單打開時的按鈕 -->
            <div
                v-if="isMobile && !collapsed"
                class="mr-3 flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg text-xl text-[#565962] transition-colors hover:bg-[rgba(196,163,90,0.12)] hover:text-[#8b6914]"
                @click="toggleCollapsed"
            >
                <menu-unfold-outlined
                    class="transition-transform duration-300"
                    :style="{
                        transform: 'rotate(180deg)'
                    }"
                />
            </div>
        </div>

        <!-- 側選單項目 -->
        <SideMenu :collapsed="collapsed" />
    </a-layout-sider>
</template>
